import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';

@Injectable()
export class OrderProductService extends ApiService {

    getOrderProducts(orderId: number, page: number = 1, limit: number = 100, q: string = '', orderField: string = '', orderDirection: string = ''): Observable<any> {
        return this.request({
            method: 'GET',
            path: `orders/${orderId}/products`,
            query: {
                q: q,
                limit: limit,
                page: page,
                orderField: orderField,
                orderDirection: orderDirection
            }
        });
    }

    getOrderById(orderId: number, id: number): Observable<any> {
        return this.request({
            method: 'GET',
            path: `orders/${orderId}/products/${id}`,
        });
    }

    deleteOrder(orderId: number, id: number): Observable<any> {
        return this.request({
            method: 'DELETE',
            path: `orders/${orderId}/products/${id}`,
        });
    }

    addOrder(orderId: number, body): Observable<any> {
        return this.request({
            method: 'POST',
            path: `orders/${orderId}/products`,
            body: body
        });
    }

    updateOrder(orderId: number, id: number, body): Observable<any> {
        return this.request({
            method: 'PUT',
            path: `orders/${orderId}/products/${id}`,
            body: body
        });
    }
}